<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
  /**
   * Vertical (`vertical`): use `headers` and `content` slots; both receive
   * `active-item` and `set-active-item`. Horizontal (`!vertical`): only the
   * default slot is rendered; compose items with horizontal accordion children.
   */
  import {ref, watch} from 'vue';
  interface AccordionProps {
    initialActiveIndex?: number;
    vertical?: boolean;
  }

  const props = defineProps<AccordionProps>();

  const activeItem = ref(props.initialActiveIndex ?? 0);
  const setActiveItem = (index: number) => {
    activeItem.value = index;
  };

  watch(
    () => props.initialActiveIndex,
    val => {
      activeItem.value = val ?? 0;
    },
  );
</script>

<template>
  <div
    v-if="props.vertical"
    class="flex-row items-stretch rounded-md overflow-hidden shadow-md flex">
    <div class="w-1/2 flex flex-col">
      <slot
        name="headers"
        :active-item="activeItem"
        :set-active-item="setActiveItem">
      </slot>
    </div>
    <div class="bg-gray-100 dark:bg-gray-800/80 w-1/2">
      <slot
        name="content"
        :active-item="activeItem"
        :set-active-item="setActiveItem">
      </slot>
    </div>
  </div>

  <div
    v-if="!props.vertical"
    class="flex flex-col border-t">
    <slot></slot>
  </div>
</template>
